/*
  Product card photos (snippets/aw-product-card.liquid).
  - Phones: native swipe (CSS scroll-snap on .aw-card__track).
  - Desktop: "hover-scrub" — moving the cursor across the photo shows photo 1, 2, 3, 4
    by position (left → right); leaving the card returns to the main photo.
  The slim segmented bar (.aw-card__dots) follows the photo on screen.
  One set of listeners covers every card, including cards added by the theme editor.
*/
(function () {
  function parts(el) {
    const media = el.closest('.aw-card__media');
    if (!media) return null;
    return {
      media,
      track: media.querySelector('[data-aw-track]'),
      dots: media.querySelectorAll('.aw-card__dots span'),
    };
  }

  function sync(track) {
    const p = parts(track);
    if (!p || !p.dots.length) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    p.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  // Photos 2–4 load only once someone shows interest in the card (see aw-product-card.liquid)
  function hydrate(media) {
    if (!media || media.dataset.awHydrated) return;
    media.dataset.awHydrated = '1';
    media.querySelectorAll('[data-aw-srcset]').forEach((el) => {
      el.setAttribute('srcset', el.getAttribute('data-aw-srcset'));
      el.removeAttribute('data-aw-srcset');
    });
    media.querySelectorAll('[data-aw-src]').forEach((el) => {
      el.setAttribute('src', el.getAttribute('data-aw-src'));
      el.removeAttribute('data-aw-src');
    });
  }

  const hydrateFrom = (event) => hydrate(event.target.closest?.('.aw-card__media'));
  document.addEventListener('pointerover', hydrateFrom, { passive: true });
  document.addEventListener('touchstart', hydrateFrom, { passive: true });
  document.addEventListener('focusin', hydrateFrom);

  function show(p, index) {
    if (!p || !p.track) return;
    const left = index * p.track.clientWidth;
    if (Math.abs(p.track.scrollLeft - left) < 2) return;
    p.track.scrollTo({ left, behavior: 'instant' });
    sync(p.track);
  }

  // Desktop hover-scrub (mouse only — touch keeps native swiping)
  document.addEventListener(
    'pointermove',
    (event) => {
      if (event.pointerType !== 'mouse') return;
      const media = event.target.closest?.('.aw-card__media');
      if (!media) return;
      const p = parts(media);
      const count = p?.dots.length || 0;
      if (count < 2) return;
      const rect = media.getBoundingClientRect();
      const ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 0.999);
      show(p, Math.floor(ratio * count));
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      if (event.pointerType !== 'mouse') return;
      const media = event.target.closest?.('.aw-card__media');
      if (!media || media.contains(event.relatedTarget)) return;
      show(parts(media), 0);
    },
    { passive: true }
  );

  // Swiping on phones: keep the bar in step. Scroll events don't bubble — use capture.
  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target;
      if (track instanceof Element && track.matches('[data-aw-track]')) {
        hydrate(track.closest('.aw-card__media'));
        sync(track);
      }
    },
    { capture: true, passive: true }
  );

  function init(root) {
    root.querySelectorAll('[data-aw-track]').forEach(sync);
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
